import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class MeritPromotionSettingsModel
  extends Model
  implements IModel<MeritPromotionSettingsModel> {
  companyId: string = "";
  excludedJobTitleGroupIds: string[] = [];

  static create(input: any): MeritPromotionSettingsModel {
    return ObjectMapper.deserialize<MeritPromotionSettingsModel>(
      MeritPromotionSettingsModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
